import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { OrderPrintoutPage, OrderPrintoutPage2 } from "~/pages/order-printout";
import { zRetrieveFrom } from "~/pages/order-printout/model/retrieve-from";

function Component() {
  const { orderId } = Route.useParams();
  const { retrieveFrom } = Route.useSearch();

  const Page = retrieveFrom === "LOCAL_STORAGE" ? OrderPrintoutPage2 : OrderPrintoutPage;

  return <Page orderId={orderId} />;
}

export const Route = createFileRoute("/{-$locale}/order-printout/$orderId")({
  component: Component,
  validateSearch: zodValidator(
    z.object({
      retrieveFrom: zRetrieveFrom,
    }),
  ),
});
